export class QuoteInsuranceProducts {
  constructor() {
    this.table = [];
    this.table1 = [];
    this.table2 = [];
    this.table3 = [];
    this.table4 = [];
  }

  table: any[];
  table1: any[];
  table2: any[];
  table3: any[];
  table4: any[];
}

export class FlowProduct {
  constructor() {
    this.classes = [];
    this.notcovered = [];
    this.covered = [];
    this.vaps = [];
    this.ratings = [];
  }

  best_value: number;
  classes: any[];
  covered: any[];
  description: string;
  insurer_id: number;
  insurer_rating: QuoteCoverOptionRating[];
  notcovered: any[];
  popular: number;
  price: number;
  premiumPrice: number;
  product_id: number;
  tpq: number;
  product_logo: any;
  product_name: string;
  short: string;
  special_offer: number;
  underwriter: string;
  underwriter_logo: string;
  vaps: QuoteCoverOptionVaps[];
  ratings: QuoteCoverOptionRating[];
}

export class FlowPageDataProduct {
  notcovered: any[] = [];
  covered: any[] = [];
  binderholder_id: number;
  broker_default_id: number;
  complaints_email: any;
  complaints_name: any;
  best_value: number;
  complaints_tel: any;
  premiumPrice = 0;
  is_ei_product: number;
  display_headsup: string;
  compliance_email: string;
  compliance_name: string;
  compliance_tel: string;
  conflict_email: any;
  contact_dept: any;
  contact_email: any;
  contact_name: any;
  contact_tel: any;
  country_id: number;
  date_updated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  email: string;
  fais_id: number;
  fax: string;
  index: number;
  insurance_authorised: any;
  insurer_id: number;
  insurer_rating: QuoteCoverOptionRating[] = [];
  insurer_type_id: number;
  lic: string;
  name: string;
  ombud_id: number;
  physical: string;
  policy_id: any;
  popular: number;
  postal: string;
  primary_insurer_id: any;
  product_category: number;
  product_code: string;
  product_description: string;
  product_id: number;
  tpq: number;
  product_logo: any;
  product_name: string;
  description: string;
  reg: string;
  sasria_id: number;
  short: string;
  short_name: string;
  tel: string;
  tial_product_id: string;
  uma_id: any;
  underwriter: string;
  underwriter_logo: string;
  user_updated: number;
  vat: string;
  website: string;
  price = 0;
  product: FlowPageDataProduct;
  ratings: QuoteCoverOptionRating[] = [];
  vaps: any[] = [];
  addonVaps: any;
  classes: any[] = [];
  discounts: any;
  mandatory: any;
  category_name: string;
  taxes: { cartItem: number; description: string; };
  serviceFee: { cartItem: number; description: string; };
  sasiria: { cartItem: number; description: string; popOver: string; };
}

export class QuoteCoverOptionVaps {
  class_id: number;
  class_name: string;
  description: string;
  item: string;
  period_type: string;
  period_val: number;
  product_id: number;
  product_rel: string;
  product_vaps_id: number;
  question_id: number;
  rate_perc: number;
  value_default: number;
  value_max: number;
  value_min: number;
  vaps_icon: string;
}

export class QuestionFlowCollation {
  begin_date: string;
  benefit_value: string;
  best_value: number;
  calc_collation_id: number;
  category_id: number;
  class_id: number;
  class_name: any;
  date_updated: any;
  dateupdated: string;
  default_val: any;
  del: string;
  description_1: string;
  description_2: string;
  discounts: string;
  display_add: any;
  display_order: any;
  edit: string;
  end_date: string;
  entry_type: string;
  excess_max: any;
  excess_min: number;
  excess_question_id: any;
  frequency_id: number;
  icon: any;
  insurer_id: any;
  insurer_rating: number;
  item_excess: number;
  level: any;
  mandatory: number;
  max_item: any;
  max_val: any;
  min_item: any;
  min_val: any;
  open_shoppingcart: number;
  popular_offer: number;
  prem_value: number;
  prod_class_rel_id: any;
  product_class_id: any;
  product_group_id: any;
  product_id: number;
  product_id1: any;
  product_subclass_id: any;
  sasria: any;
  session_id: string;
  session_item_id: string;
  si_question_id: any;
  special_offer: number;
  status_id: number;
  tax_id: any;
  uw_result: number;
  val_max: number;
  val_min: number;
  vaps: string;
  vaps_id: number;
  discountList: any[];
}

export class QuoteCollationVap {
  add_flag: number;
  begin_date: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  benefit_value: number;
  calc_collation_vaps_id: string;
  category_id: number;
  class_id: number;
  date_updated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  dateupdated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  detail: string;
  edit: number;
  end_date: any;
  excess_min: number;
  index: number;
  insurer_id: number;
  option_id: number;
  premium: number;
  premium_display: number;
  product_id: number;
  product_vaps_id: number;
  product_vaps_rel: string;
  question_id: number;
  remove: number;
  select: number;
  session_id: string;
  session_item_id: string;
  status_id: number;
  show_price: number;
  uw_result: number;
  vaps_description: string;
  vaps_icon: string;
  vaps_name: string;
  frequency_id: number;
  vaps_type_id: number;
}

export class QuoteCollation {
  add_flag: number;
  begin_date: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  benefit_value: any;
  benefit_value_raw: number;
  best_value: number;
  calc_collation_id: string;
  category_id: number;
  class_id: number;
  class_name: string;
  dateupdated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  del: any;
  description_1: string;
  description_2: string;
  description: string;
  discounts: string;
  display_order: any;
  edit: any;
  end_date: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  entry_type: string;
  excess_max: any;
  excess_min: number;
  excess_question_id: any;
  general: any;
  icon: any;
  index: number;
  insurer_rating: number;
  item_excess: number;
  item_excess_raw: number;
  mandatory: number;
  open_shoppingcart: number;
  popular_offer: number;
  prem_value: number;
  product_group_id: any;
  product_id: number;
  sasria: any;
  session_id: string;
  session_item_id: string;
  si_question_id: any;
  special_offer: number;
  status_id: number;
  uw_condition: any;
  uw_result: number;
  val_max: number;
  val_min: number;
  vaps_id: number;
  interval: number;
  frequency_id: number;
  prorata_json: any;
  is_tpq_product: any
}

export class QuoteCustomize {
  binderholder_id: number;
  broker_default_id: number;
  bundle_disc: number;
  category_id: number;
  class_id: number;
  comments: string;
  country_id: number;
  date_updated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  dependency: any;
  description: string;
  display_order: any;
  fais_id: number;
  index: number;
  insurer_id: number;
  name: string;
  ombud_id: number;
  option: number;
  period_type: any;
  period_val: number;
  popular: number;
  prod_vaps_rel_id: number;
  product_category: number;
  product_code: string;
  product_description: string;
  product_id: number;
  product_logo: any;
  product_name: string;
  product_rel: string;
  product_vaps_id: number;
  question_id: number;
  rate_flat: number;
  rate_id: any;
  rate_perc: number;
  sasria_id: number;
  short: string;
  tial_product_id: string;
  uma_id: any;
  underwriter: string;
  underwriter_logo: string;
  unit_default: number;
  unit_max: number;
  unit_min: number;
  unit_type: any;
  value_default: number;
  value_max: number;
  value_min: number;
  vaps_description: string;
  vaps_icon: string;
  vaps_name: string;
  vaps_type_id: number;
}

export class QuotePageDataVaps {
  binderholder_id: number;
  body_html: string;
  broker_default_id: number;
  bundle_disc: number;
  category_id: number;
  class_id: number;
  class_name: any;
  comments: number;
  country_id: number;
  date_updated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  dependency: any;
  description: string;
  display_order: any;
  edit: number;
  fais_id: number;
  heading_html: string;
  index: number;
  insurer_id: number;
  name: string;
  ombud_id: number;
  option: number;
  period_type: any;
  period_val: number;
  popular: 1;
  prod_vaps_rel_id: number;
  product_category: number;
  product_code: string;
  product_description: string;
  product_id: number;
  product_logo: any;
  product_name: string;
  product_vaps_rel: string;
  product_rel: string;
  product_vaps_id: number;
  answer: string;
  question_id: number;
  rate_flat: number;
  rate_id: any;
  rate_perc: number;
  remove: number;
  sasria_id: number;
  short: string;
  tial_product_id: string;
  uma_id: any;
  underwriter: string;
  underwriter_logo: string;
  unit_default: number;
  unit_max: number;
  unit_min: number;
  unit_type: any;
  value_default: number;
  value_max: number;
  value_min: number;
  vaps_description: string;
  vaps_icon: string;
  vaps_name: string;
  add_flag: number;
}

export interface QuoteCoverOptionRating {
  insurer_id: number;
  insurer_name: string;
  insurer_rating: number;
  rating_denom: number;
  rating_score: number;
  rating_type: string;
  star_css: string;
}

export interface QuoteCoverOptionBenefitTable {
  class_id: number;
  description: string;
  name: string;
  product_id: number;
  product_name: string;
  product_rel: string;
  product_vaps_id: number;
  vaps_description: string;
}


export class FlowPageDataPerson {
  address: string;
  businessname: any;
  date_updated: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  dob: string;
  email: string;
  firstname: string;
  id_no: string;
  id_type: string;
  index: number;
  lastname: string;
  mobile: string;
  passport_no: any;
  reg_no: any;
  token: string;
  verified: number;

}

export class FlowSummary {
  product: FlowPageDataProduct;
  pageDataProduct: FlowPageDataProduct;
  person: FlowPageDataPerson;
  collations: QuestionFlowCollation[];
  classes?: [{
    classId?: number;
    className?: string;
    showDropdown?: boolean;
    classItems?: [{
      description0?: string;
      description1?: string;
      amount?: number;
    }],
  }];
  vaps?: {
    items?: string;
    bundleValue?: number;
  };
  addonVaps?: {
    items?: string;
    bundleValue?: number;
  };
  discounts?: any[];
  mandatory?: [{
    className?: string;
    description?: string;
    amount?: number;
  }];
  taxes?: {
    cartItem?: number;
    description?: string;
  };
  serviceFee?: {
    cartItem?: number;
    description?: string;
  };
  sasiria?: {
    cartItem?: number;
    popOver?: string;
    description?: string;
  };
}

export class SelectedProductBenefits {
  product: FlowProduct;
  classes: [{
    classId: number;
    className: string;
  }];
  benefits: [{
    items: [{
      vapName?: string;
      vapVapsDescription?: string;
      vapDescription?: string;
    }];
    classId?: number;
    className?: string;
  }];
}

export class SelectedProductCover {
  product: FlowProduct;
  classes: [{
    classId: number;
    className: string;
  }];
  covered: [{
    items: [{
      coveredItem?: string;
      coveredDescription?: string;
    }];
    classId?: number;
    className?: string;
  }];
  unCovered: [{
    items: [{
      notCoveredItem?: string;
      notCoveredDescription?: string;
    }];
    classId?: number;
    className?: string;
  }];
}
